import Lookup from './lookup.js';

export default class Skill extends Lookup
{
    
}
